export default "__VITE_ASSET__BSrUETht__"